module.exports = {
  apps:{
    threejs: {
      bigFileMsg: ' please use Layout application instead',
      creatingGeometry: 'Creating geometry...',
      error: 'Error',
      downloadFileMb: 'Download file: %{mb} MB',
      drawNumLayers: 'Draw: %{num} layers...',
      loadingInfo: 'Loading info...',
      couldntLoadURLErrorCode: 'Couldn\'t load URL, error code: ',
      couldntLoadURL: 'Couldn\'t load URL ',
      waitingFileConversion: 'Waiting for file conversion',
      loadingModelInfillPart: 'Loading model infill part ',
      loadingModelWallsPart: 'Loading model walls part ',
      loadingPart: 'Loading part ',
      conversionFileError: 'Conversion file error',
      fileCanCrashBrowser: 'The file you are trying to open is > %{mb} megabytes, this can crash your browser',
      loadAnyway: 'Load anyway',
      nav: {
        translate: 'Move (M)',
        rotate: 'Rotate (R)',
        scale: 'Scale (C)',
        onbed: 'Put on bed (Z)',
        center: 'Center object (A)',
        selectObjExtruder: 'Select object extruder',
        cameraTop: 'Top camera (T)',
        add: 'Add new object (N)',
        save: 'Save (ctrl+S)',
        gcodePrint: 'Print file (p)',
        undo: 'Undo (ctrl+Z)',
        redo: 'Redo (ctrl+Y)',
        fullscreenPopup: 'Fullscreen (ctrl+F)',
        minimizePopup: 'Minimize (ctrl+M)',
        ruler: 'Toggle rulers (ctrl+H)',
        space: 'Toggle transform axis (Q)',
        snap: 'Snap to grid (V)',
        planecube: 'Build volume cube (B)',
        removeObj: 'Delete object (D)',
        showhideObj: 'Show/hide object',
        copy: 'Copy object (ctrl+D)',
        rename: 'Rename object',
        selectExtruder: 'Select extruder',
        wireframeMode: 'Wireframe mode',
        showhide: 'Toggle grid (G)',
      }
    },
    upload:{
      dad: 'Drag and drop to upload content!',
      select: 'select from computer'
    },
    magicFix:{
      appName: 'Magic Fix',
      fixModel: 'Fix Model'
    },
    toolpath:{
      Printer: 'Printer',
      Camera: 'Camera',
      front:'Front',
      back: 'Back',
      right: 'Right',
      left: 'Left',
      top: 'Top',
      bottom: 'Bottom',
      onObject: 'On object',
      viewLayers: 'View layers',
      info: 'Info',
      speed: 'Speed',
      mm: 'mm',
      min: 'min',
      ext: 'Ext',
      laers: 'Layers',
      range: 'Range',
      height: 'Height',
      extrusion: 'extrusion',
      showServiceParts: 'Show service parts',
      showMotion: 'Show motion',
      animation: 'Animation',
      filament: 'Filament',
      estimatedPrintTime: 'Estimated print time',
      raft :'Raft',
      extruder: 'Extruder',
      supports: 'Supports',
      temperature: 'temperature',
      duration: 'duration',
      // new
      loading: 'loading',
      fileInfo: 'File info',
      fileId: 'File ID',
      fileName: 'File name',
      printingDuration: 'Printing duration',
      heatedDedTemperature: 'Heated bed temperature',
      showExtrusion: 'Show extrusion',
      showInfill: 'Show infill',
      appName: 'Toolpath Viewer',

      ExTemp1:"Extruder 1 temperature:",
      ExTemp2:"Extruder 2 temperature:",
      ExMat1:"Extruder 1 Material:",
      ExMat2:"Extruder 2 Material:",
      yes: 'yes',
      no: 'no',
      notavail: 'n/a',
      meter: 'm',
      mmPerSecond: 'mm/s',
      gram: 'g',
      max: 'max',
      hour: 'h',
      extruderNumFilament: 'Extruder %{num} filament',
      cost: 'Cost',
      objectExtendsBeyondBed: 'The object extends beyond the bed',
    },
    editor:{
      sliceInfo: 'Slice Info',
      move: 'Move',
      rotate: 'Rotate',
      scale: 'Scale',
      undo: 'Undo',
      extrra: 'Extra',
      addFiles: 'Add files',
      position: 'Position',
      update: 'Update',
      reset: 'Reset',
      onBed: 'On bed',
      center: 'Center',
      optimalRatete: 'Optimal Rotate',
      inch: 'inch',
      maxBedZize: 'Max bed size',
      keepProportions: 'keep proportions',
      firstExtruder: 'First extruder',
      secondExtruder: 'Second extruder',
      apply: 'Apply',
      // new
      extruder: 'Extruder',
      analyze: 'Analyze',
      free: 'Free',
      addFile: 'Add File',
      slice: 'Slice',
      selectExtruder: 'Select extruder',
      copy: 'Copy',
      quantity: 'Quantity',
      selectFile: 'Select file',
      singleFile: 'Single file',
      refresh: 'Refresh',
      resetRotate: 'Reset Rotate',
      scaleTo: 'Scale to',
      resetScale: 'Reset scale',
      align: 'Align',
      // 2
      appName: 'STL Editor',
      hide: 'Hide',
      rename: 'Rename',
      mirror: 'Mirror',
      centered: 'Centered',
      selectDefLable:'Single file from the MY FILES tab',

      newName: 'New name',
      show: 'Show',
      youCantRemoveLastObject: 'You can\'t remove last object',
      projects: 'Projects',
      objectBiggerPrinterBox: 'The object is bigger than the printer box',
      objectsOutPrinterBox: 'The objects %{objs} are out of the printer box',
      objectOutPrinterBox: 'The object is out of the printer box',
    },
    slicer: {
      simple: 'Simple',
      advanced: 'Advanced',
      expert: 'Expert',
      price: 'Price',
      save: 'Save these settings as a slicing profile',
      slicerSettingsFor: 'Slicer settings for',
      selectPrinterType: 'Select Printer type',
      selectSlicingProfile: 'Select slicing profile',
      layerThickness : 'Layer thickness',
      shellThickness: 'Shell thickness',
      infill: 'Infill',
      table: 'Table',
      platfAdhesion: 'Platf. Adhesion',
      supports: 'Supports',
      reCenter: 'Recenter object before slicing',
      material: 'Material',
      cooling: 'Cooling',
      nozzleDiameter:  'Nozzle diameter(mm)',
      filamentFlow: 'Filament flow(%)',
      quality: 'Quality',
      bottomTopThick: 'Bottom/top thick',
      brimLineAmount: 'Brim line amount',
      printSpeed: 'Print speed',
      bottomLayerSpeed: 'Bottom layer speed',
      travelingSpeed: 'Traveling speed',
      retractionDistance: 'Retraction distance',
      heatedBed: 'Heated bed',
      fanSpeedMin: 'Fan speed min',
      fanSpeedMax: 'Fan speed max',
      fanFullOnHeight: 'Fan full on height',
      minimalLayer: 'Minimal Layer Time',
      coolingFan: 'Cooling fan',

      // new
      openSTLEditor: 'Open STL Editor',
      longer: 'longer',
      weak: 'weaker',
      light: 'weaker',
      faster: 'faster',
      strong: 'stronger',
      size: 'Size',
      appName: 'Slicer',
    }
  },
  firstLogin: {
    hello: 'Hello! You are in the Diaprint Cloud application.',
    toGetTheActivation: 'To get the activation code and get started, link your 3D printer to your Diaprint account:',
    goTo: 'Go to the "Printers" section',
    pressBtn: 'Click the "Add Printers" button',
    enterSnNumber: 'Enter the serial number and receive the activation code',
    addActive: 'Activate 3D printer with code',
    close: 'Close',
    addPrinter: 'Add Printer'
  },
  login:{
    signIn: 'Sign In',
    signUp: 'Sign Up',
    sso: 'SSO',
    btn:{
      back:'Back'
    },
    or: 'Or',
    password: 'Password',
    confirmYourEmail: 'Confirm your email',
    passwordReset: ' Password reset',
    forgotPassword:'Forgot Password?',
    notActivated: 'Activation account link was sent to your email',
    selectSchool: 'Select School, University or Business',
    enterWith: 'Enter with',
    email: 'Email',
    firstName:'Firstname',
    lastName:'Lastname',
    phone: 'Phone (+79150000001)',
    phoneTitle: 'Enter a phone number in format +7ХХХХХХХХХХ',
    company: 'Company',
    repeatPassword:'Repeat password',
    createAccount: 'Create account',
    minSymbols: 'min %{count} symbols',
    reset: 'Reset',
    goTo3DPos: 'Go to 3DPrinterOS',
    enterYourAccountEmail: 'Enter your account email',
    resendEmail: 'Resend email',
    ifYouDoreceiveTheEmail: 'If you don’t receive the email, press resend button',

    iHaveRead:  'I have read <a href="%{termsOfService}" target="_blank">Terms of Service</a> and <a href="%{privacyPolicy}" target="_blank">Privacy Policy</a> and I am giving <strong>all consents</strong>.',
    iAgree:  'I agree to provide my email and IP address for general and security purposes of the 3DPrinterOS system  (Required)',
    iAm: 'I am more than 16 years old / I am a parent of the user who is younger than 16 and give consent to process their personal data (Required).',
    iGreeToAhare: 'I agree to share some of my personal data with 3DPrinterOS social network',
    verification: {
      title: 'Verification',
      firstDesc: '1. Open Google Authenticator app on your phone',
      secondDesc: '2. Find account "3DPrinterOS %{email}"',
      thirdDesc: '3. Enter account code below',
      code: 'Verification Code',
      verify: 'Verify'
    },
    no_gdpr: 'We can\'t create the account without your consent on proceeding your email',
    captcha_not_valid: 'reCaptcha token is not valid',
    repeatPasswordNotNeeded: 'Repeat password is not needed. Remember the one you entered.',
    checkEmailForPasswordReset: 'Please check your email. The password reset has been sent!',
    beSureToReLogin: 'Please be sure to re-login all 3DprinterOS Clients related to this account.'
  },
  profiles:{
    tabs: {
      active: 'Active',
      deleted: 'Deleted',
      default: 'Default',
    },
    buttons: {
      'addProfile': 'Add profile'
    },
    actions: {
      access: 'Access',
      edit: 'Edit',
      restore: 'Restore',
      delete: 'Delete',
      rename: 'Rename',
      makeDefault: 'Make default',
      removeDefault: 'Move to my profiles'
    },
    search: 'Search',
    confirmRestore: 'Are you sure you want to restore the profile?',
    failedRestore: 'Failed to restore profile:',
    makeAsDefaultButton: 'Make as default',
    makeDefaultNamePopupText: 'Are you sure you want to standardize the profile? All users of the software will be able to use it.',
    makeDefaultNamePopupNameField: 'Enter the name of default profile',
    confirmMakeDefaultReplace: 'Default profile with name %{name} has already exists. Are you sure you want to replace default slicing profile?',
    confirmRemoveAfterMakeDefault: 'Profile was successfully made as default. Do you want to delete profile from your active profiles?',
    failedToDeleteProfile: 'Failed to delete slicing profile',
    confirmDeleteDefaultProfile: 'Are you sure you want to delete default profile? Software users will no longer be able to use it.'
  },
  files: {
    size:{
      b:'b',
      kb: 'Kb',
      mb:'Mb',
      gb:'Gb',
      tb: 'Tb',
    },
    apps: {
      layout: 'Layout',
      preview: 'Preview'
    },
    base:{
      files: 'files',
      selected: 'selected',
      email: 'Email',
      add: 'Add',
      workgroup: "Workgroup",
      selectPrinters:'Select 3d Printer',
      print: 'Print',
      title: 'Title',
      apps: 'Apps',
      actions: 'Actions',
      selectAll: 'Select All',
      selectUnSelectAll: 'Un-select All',
    },
    msg:{
      noJobsWasExecutedForTheFile:'No jobs was executed for the file',
      fileDeleteTooltips: 'Deleted. You can restore this file until the next website use.'
    },
    shareFiles:{
      unsharingFailed: 'Unsharing failed',
      failedtoUnshareFile: 'Failed to unshare file',
      fileOwnerBeremove: 'File owner, couldn\'t be removed',
      invalidEmail: 'Email is not valid'
    },
    action:{
      addFiles:'Add files',
    },
    multiActions: {
      moveToProject: 'Move to project',
      copyToProject: 'Copy to project',
    },
    modal:{
      moveFilesToProject:'MOVE FILES TO PROJECT',
      copyFilesToProject:'COPY FILES TO PROJECT',
      repair:{
        info:'Use the Magic Fix App to prepare designs automatically for 3D Printing. Magic Fix converts Cad files to Stl, analyzes, repairs, and rotates files for printing exactly on your unique 3D Printer.',
        notes: 'Note: only 3ds, 3mf, amf, obj, and stl formats are supported.',
        moveObject: 'Move the object to the center of the build plate',
        rotateObject: 'Rotate object for the specific 3D Printer build plate',
        autoSize: 'Auto resize object for printing *',
        scaleObject: '* Scales object bigger than 50 cm by 10x down and objects smaller than 2mm by 10x up',
      },
      fileEdit:{
        defaultSlicingProfiles: 'Default slicing profiles',
        publicSharing: 'Public sharing',
        allowToDisplayInSearch: 'Allow displaying in the public search'
      },
    },
    navbar: {
      files: 'Files',
      projects: 'Projects',
      profiles: 'Profiles',
    },
    typeTooltip: {
      loading: 'Loading...',
      unavailable: 'File info doesn\'t available',
      maxDimensions: 'Max dimensions',
      na: 'n/a',
      modelVolume: 'Model volume',
      printerType: 'Printer type',
      layerHeight: 'Layer height',
      extruders: 'Extruders',
      bedTemperature: 'Bed temperature',
      length: 'Length',
      cost: 'Cost',
      weight: 'Weight',
      estimatedTime: 'Estimated time'
    },
    selectPrinterType: 'Select Printer type',
    jobDetails: {
      summary: 'Summary',
      sharing: 'Sharing',
      details: 'Log&Details',
      preparePrint: 'Prepare a Print',
      withQuickPrint: 'With QuickPrint App'
    }
  },
  menu: {
    history: 'History',
    files: 'Files',
    projects: 'Projects',
    profiles: 'Profiles',
    printers: 'Printers',
    download: 'Download',
    support: 'Support',
  },
  buttons: {
    add: 'Add',
    edit: 'Edit',
    ok: 'Ok',
    cancel: 'Cancel',
    close: 'Close',
    save: 'Save',
    removed: 'Remove',
    download: 'Download',
    unshare: 'Unshare',
    delete: 'Delete',
    share: 'Share',
    stop: 'Stop',
    undo: 'Restore',
    deleted: 'deleted',
    submit: 'Submit',
    print: 'Print'
  },
  projects:{
    delete: 'You are going to  %{action}  the %{projectName} project, please confirm your action.'
  },
  printers: {
    status: {
      idle: 'idle',
      bed_not_clear: 'bed not clear',
      printing: 'printing',
      heating: 'heating',
      paused: 'paused',
      offline: 'offline',
      manual_control: 'manual control',
      cancelling_print: 'canceling print',
      notconnected: 'not connected',
      printing_locally: 'printing locally',
      error: 'error',
      connecting: 'connecting',
      downloading: 'downloading',
      Virtual: 'industrial',
      local_mode: 'local mode',
      change_filament: 'change filament'
    },
    navbar: {
      printers: 'Printers',
      liveViewWall: 'Liveview wall',
      search: 'Search',
      addPrinter: 'Add Printer',
      activePrinters: 'Active Printers',
      activePrintersByHost: 'Active Printers by host',
      inactivePrinters: 'Inactive Printers',
      createIndustrialPrinter: 'Create industrial Printer',
      addWorkgroupPrinters: 'Add workgroup Printers'
    },
    buttons: {
      connectToWorkgroup: 'Connect to workgroup'
    },
    form: {
      addNew: {
        title: 'Select or type your 3D Printer(s) Make and Model',
        selectPrinterType: 'Select Printer type',
        remove: 'Remove',
        addPrinters: 'Add Printers',
        errorTitle: 'Add Printer(s) Error'
      },
      addIndustrial: {
        title: 'ADD INDUSTRIAL PRINTER/CNC'
      }
    },
    disconnected: {
      waitingConnection: 'Waiting for connection',
      token: 'Token',
      tokenTooltip: 'Enter the token from the screen of your 3D Printer. You can find 3DPrinterOS Cloud connection in settings',
      howToGet: 'how to get',
      connect: 'Connect',
      notSupportedText: 'This model is not supported for Direct drive. Please, <span>contact support</span> for it\'s registration.',
      connectInstruction: 'Follow <a target="_blank" href="%{link}">the instructions</a>  to connect this Printer',
      runClient: 'Run <a target="_blank" href="%{downloadLink}">3DPrinterOS client</a> and follow the instructions to connect this Printer',
      connectPrinterToInternet: 'Connect Printer to the internet',
      remove: 'Remove',
      makeIndustrial: 'Make industrial',
      regErrorTitle: 'Registration Printer Error',
      regErrorByCode: 'Failed to register Printer by code',
      removeErrorTitle: 'Remove Disconnected Printer Error',
      removeError: 'Failed to remove disconnected Printer'
    },
    inactive: {
      noPrinters: 'No inactive Printers',
      delete: 'Delete',
      unhide: 'Unhide Printer',
      restoreErrorTitle: 'Restore Printer error',
      restoreError: 'Failed to restore Printer'
    },
    item: {
      queue: 'Queue',
      printing: 'Printing',
      job: 'jobs | job | jobs',
      share: 'Share',
      printerSettings: 'Printer settings',
      printerLog: 'Printer logs',
      jobSorting: 'Manual jobs sort',
      finishJobSorting: 'Finish manual job sort',
      moveAllJobs: 'Move all jobs',
      buildTrayIsClear: 'Build Tray is clear',
      clearBuildTrayErrorTitle: 'Clear build tray error',
      clearBuildTrayError: 'Failed to clear build tray',
      flags: {
        doorOpen: 'Door open',
        noFilament: 'No filament',
        filamentClogged: 'Filament clogged',
        bedNotClear: 'Bed is not clear'
      },
      buttons: {
        closeWithoutSaving: 'Close without saving',
        saveChanges: 'Save changes'
      },
      timeLeft: 'Time left',
      jobSortingMode: {
        newFirst: 'New is the first',
        oldFirst: 'Old is the first',
        estimatedTime: 'Estimated time',
        weight: 'Weight',
        cost: 'Cost',
        manual: 'Manual sorting'
      },
      extruder: 'Extruder',
      ext1: 'Extruder 1',
      ext2: 'Extruder 2',
      heatBed: 'Heated bed',
      chamb: 'Chamber',
    },
    camera: {
      noCamera: 'No Camera',
      cameraName: 'Camera %{num}'
    },
    select: {
      fav: 'Favorite Printers',
      my: 'My Printers',
      all: 'All Printers'
    },
    host: {
      localIp: 'Local IP',
      macAddress: 'MAC Address',
      versionWarning: 'Please download and update to the latest (%{lastVer}) version of Cloud Client. Your current version is outdated.',
      versionWarningDetailed: 'Please download and update to the latest (%{lastVer}) version of Cloud Client. Your current version %{userVer} might be outdated.'
    },
    job: {
      pause: 'Pause',
      start: 'Start',
      restart: 'Restart',
      resume: 'Resume',
      finish: 'Finish',
      cancel: 'Cancel',
      error: 'Error',
      details: 'Details',
      download: 'Download',
      copy: 'Copy',
      notes: 'Notes',
      buildTrayIsNotClearTooltip: 'Build tray is not clear',
      printErrorTitle: 'Printing Error',
      confirmPause: 'Are you sure you want to pause the job? This can cause defects of the print?',
      confirmPrintError: 'Please confirm the failure of the job?',
      denyFilename: 'Sorry, you are not allowed to see the file name',
      denyAuthor: 'Sorry, you are not allowed to see the author',
      status: {
        queue: 'In queue',
        progress: 'In progress',
        pause: 'Pause',
        failed: 'Failed',
        failedStreaming: 'Failed (streaming error)',
        failedSuspiciousActivity: 'Failed (Suspicious activity)',
        aborted: 'Aborted',
        finished: 'Finished',
        unknown: 'Unknown'
      },
      transaction: {
        refund: 'Refund',
        withdraw: 'Withdraw',
        newCost: 'New cost',
        desc: 'Description',
        update: 'Update',
        noteText: 'You can change the print job price on this page. Then the difference will be deducted or added to the final invoice.',
        loadingError: 'Failed to load job transactions',
        errorLess0: 'The new cost can\'t be less than 0.',
        errorCostNotDiffer: 'The new cost doesn\'t differ from the current.',
        confirmRefund: 'Are you sure you want to REFUND to the job owner %{currency}%{amount}?',
        confirmWithdraw: 'Are you sure you want to WITHDRAW from the job\'s owner %{currency}%{amount}?',
        errorMessage: 'Failed to create the transaction',
        transType: 'Type',
        amount: 'Amount',
        date: 'Date',
        comment: 'Comment',
        createTransaction: 'Create transaction'
      },
      actions: 'Actions'
    },
    modal: {
      addIndustrial: {
        printerType: '3D Printer / CNC Type',
        selectPrinterType: 'Select Printer type',
        printerHost: '3D Printer / CNC Host',
        selectPrinterHost: 'Select host',
        printerName: '3D Printer / CNC Name',
        addRandomHost: 'Add randomly generated host',
        activeHostGroup: 'Active hosts',
        otherHostGroup: 'Other hosts',
      },
      cancellationReason: {
        title: 'Why have you canceled this job? Please select one or more reasons:',
        hardwareIssues: '3D Printer hardware issues:',
        slicerIssues: 'Slicer issues:',
        designIssues: 'Design file/job issues:',
        describeProblemMore: 'Please describe more precisely what problem did you experience?',
        notifyJobOwner: 'Notify job owner over email too',
        reasons: {
          nozzleClogged: 'Nozzle Clogged',
          bedCalibration: 'Bad calibration',
          notSticking: 'First layer not sticking',
          underextrusion: 'Underextrusion',
          mechanical: 'Mechanical part malfunction',
          electrical: 'Electrical part malfunction',
          firmwareIssue: 'Firmware issue',
          filamentLack: 'Lack of filament',
          slicerSettings: 'Wrong slicer settings',
          slicingQuality: 'Bad quality slicing',
          printingSpeed: 'Wrong printing speed',
          printingTemperature: 'Wrong printing temperature',
          position: 'Wrong position on a build tray',
          file: 'Wrong file',
          dontNeed: 'Don\'t need this print anymore',
          anotherPrint: 'Another high priority print',
          size: 'The design is too large/small'
        }
      },
      choosePrinter: {
        move: 'Move',
        copy: 'Copy',
        print: 'Print',
        queue: 'Queue',
        continue: 'Continue with %{action}',
        shareLabel: 'Share Printer with only "state view" access to the original user if it has not been shared already – Then the user can see his job state',
        errorLoadingJobData: 'Failed to get job data',
        errorCopyJob: 'Failed to copy job',
        errorMoveJob: 'Failed to move job',
        errorQueueJob: 'Failed to add jobs into the queue',
        errorQueueMultipleJobs: 'Failed to send next files into the queue: %{filenames}',
        errorRestartJob: 'Failed to restart the job',
        successQueue: 'Your print job has been sent to the queue',
        successPrint: 'Your print job has been started',
        goToPrinters: 'Go to Printers',
        selectPrinter: 'Select Printer',
        addNote: 'Add a note',
        choose3dPrinter: 'Choose 3D Printer',
        qaNotValid: 'Please set values for all required fields',
        noPrinters: 'There are no available Printers',
        buildTrayNotClear: 'Build tray is not clear',
        filamentNotEnough: 'Filament not enough',
        queueDisabled: 'The queue is disabled on the Printer'
      },
      confirmJobCancel: {
        title: 'You are going to cancel the %{fileName} on %{printerName}',
        errorCancelJob: 'Failed to cancel job %{jobId}',
        cancelJob: 'Cancel job',
        back: 'Take me back'
      },
      confirmDeletePrinter: {
        deleteWarning: 'You are going to delete the Printer',
        deleteWarningIndustrial: 'You are going to delete the <span class="text-danger">industrial</span> Printer',
        forAllUsers: ' for all users.',
        fromYourAccount: ' from your account',
        confirmAction: 'Please confirm the action.',
        ps: 'P.S. Be careful, You can\'t undo this action. All sharings will be removed for this Printer. All the jobs in the queue will be lost permanently.',
        psAdmin: 'The Printer will be unset from all workgroups and will be removed for the entire organization.',
        affectedPrinter: 'Affected Printer',
        errorDeletePrinter: 'Failed to delete Printer',
        delete: 'Delete'
      },
      editHost: {
        title: 'Title',
        location: 'Location',
        colour: 'Colour',
        setLocation: 'Set location',
        errorEditHost: 'Failed to edit the host name',
        errorEditColor: 'Failed to edit host color'
      },
      jobDetails: {
        logs: 'Logs',
        summary: 'Summary',
        notes: 'Notes',
        settings: 'Settings',
        timelaps: 'Timelapse',
        transactions: 'Transactions',
        noTimelaps: 'No Timelapse',
        settingsUnavailable: 'Slicing settings unavailable, job file was not sliced',
        noSettings: 'No Slicing Settings',
        errorLoadingSettings: 'Failed to load slicing settings',
        noLogs: 'No Logs',
        errorLoadingLogs: 'Failed to load job logs',
        openToolpath: ' Open in toolpath viewer',
        openStlEditor: 'Open in STL editor',
        estimatedTime: 'Estimated time',
        filament: 'Filament',
        status: 'Status'
      },
      jobNotes: {
        qa: 'Questions & Answers',
        notePlaceholder: 'Note...',
        types: {
          note: 'Note',
          feedback: 'Feedback'
        },
        addNote: 'Add note',
        errorLoadingNotes: 'Failed to load job notes',
        errorAddNote: 'Failed to add job note'
      },
      printerSettings: {
        announcement: 'Announcement',
        announcementPlaceholder: 'Message to display on the status line',
        filamentTracking: 'Filament tracking',
        filament: {
          left: 'Left',
          nozzle: 'Nozzle'
        },
        displayTitle: 'Display title',
        active: 'Active',
        enableQueue: 'Enable queue',
        enableClearBed: 'Enable clear bed notification/button',
        forRpiGPIO: 'For Raspberry Pi GPIO',
        startNextJobButton: 'Start next job button',
        camera: 'Camera',
        dualCamera: 'Dual',
        piCamera: 'PI',
        multiCamera: 'Multi',
        resetModule: 'Reset module',
        delete: 'Delete',
        yourEmail: 'Your email',
        removePrinter: 'Delete this Printer',
        owner: 'Owner',
        changeAccountNote: 'This account could be changed via support',
        removeOnlinePrinterTooltip: 'You can\'t delete an online Printer. Please, turn it off before deleting.'
      },
      sharePrinter: {
        ownerCantBeDeleted: 'Printer\'s owner, couldn\'t be removed',
        emailsToAllow: 'Emails to allow...',
        limit: 'limit',
        add: 'Add',
        notExists: 'Not exists',
        emailDoesNotBelong: 'Email does not belong to any existing users. You can invite this email owner to 3DPrinterOS and share the Printer with her/him.',
        notMemberOfOrg: 'Not a member of the organization',
        notMemberOfOrgDesc: 'This user is not a member of your organization. The printing limitations are not working for her/him (clear bed notifications, access rights customizations, etc.). Please, accept the sharing without the printing limitations.',
        invite: 'Invite',
        accept: 'Accept',
        inviteAll: 'Invite all',
        acceptAllNonOrg: 'Accept all non-org members',
        owner: 'Owner',
        limitless: 'limitless',
        limitNumber: 'limit %{number}',
        confirmUnshare: 'Are you sure you want to unshare the Printer?',
        errorUnsharePrinter: 'Failed to unshare the Printer',
        errorEmailDontBelong: 'This email does not belong to any existing users',
        errorNotMember: 'User is not a member of your organization',
        invalidEmail: 'Email is not valid'
      },
      workgroupAccess: {
        desc: 'Please enter the Workgroup access code you received from your teacher or 3D printing laboratory administrator.',
        noCodeDesc: 'If you don\'t have a Workgroup access code for your university,  please ask it from the Course teacher or 3Dprinting Lab Administrator.',
        accessCode: 'Access code',
        notJoinedEducationalProgram: 'If your university has not yet joined the 3DPrinterOS Educational program please fill in <a href="%{quoteLink}" target="_blank">this form</a>, and we will help your university to make Printers accessible for students.'
      },
      add_imprinta_printer: {
        title: 'Add new printer',
        enter_serial_number: 'Enter serial number to add new printer',
        serial_number: 'Printer serial number',
        activate_printer: 'Your printer still has not activated. Enter PIN code on the printer display.<br/>After connection to the internet, your printer will be available for cloud printing<br/><div class="printer-pin-code">%{hash}</div>',
        printer_added: 'Printer was successfully added to your account.<br />After connection to the internet, your printer will be available for cloud printing.',
        failedToAdd: 'Failed to add new printer',
        wrongSerialNumber: 'Wrong serial number',
        serialnumberWasRegistered: 'This serialnumber was already registered',
      },
      printerLog: {
        close: 'Close'
      }
    },
    shareRoles: {
      canPrint: 'Can print',
      canPrintCustom: 'Can print (custom)',
      canQueueCustom: 'Can queue (custom)',
      canQueue: 'Can queue',
      unknown: 'Unknown'
    }
  },
  history: {
    nav: {
      me: 'Me',
      org: 'Organization',
      search: 'Search by Printer, user, job'
    },
    stat: {
      hoursPrinted: 'Hours Printed',
      prints: 'Prints',
      printing: 'Printing',
      inQueue: 'In queue',
      errors: 'Errors',
      materialsUsed: 'Materials used (kg)'
    },
    noResult: 'No result',
    by: 'by',
    ownEmail: 'me',
    actions: {
      restart: 'Restart',
      details: 'Details',
      notes: 'Notes',

    }
  },
  dateRangePicker: {
    selectDateRange: 'Select date range',
    lastWeek: 'Last week',
    lastMonth: 'Last Month',
    lastYear: 'Last Year'
  },
  measure: {
    shortcut: {
      gram: 'g',
      millimeter: 'mm',
      meter: 'm.',
      hours: 'h'
    }
  },
  printTime: {
    estimated: 'estimated',
    actual: 'actual',
    estimatedTime: 'Estimated time',
  },
  userMenu: {
    storageAvailable: 'Storage available',
    bandwidthAvailable: 'Bandwidth available',
    superAdmin: 'Super Admin',
    organisationAdmin: 'Organization admin',
    releaseNotes: 'Release notes',
    myProfile: 'My profile',
    customization: 'Customization',
    oldDarkTheme: 'Old dark theme',
    oldLightTheme: 'Old light theme',
    newTheme: 'New theme beta',
    profileSettings: 'Profile setting',
    changePassword: 'Change password',
    logout: 'Sign out',
    licenseUnactivated: 'License unactivated'
  },
  notification: {
    printerNoSpace: 'There is not enough space available on %{printerName} to run %{jobName}. Please delete old jobs from the screen of %{printerName}.'
  },
  releaseNotes: {
    title: 'Release Notes',
    info: '<ul>\n' +
      '<li> Integrate Hegcules G2 into the cloud </li> \n' +
      '<ul> \n' +
      '<li> 3D printer activation </li> \n' +
      '<li> send files for printing, </li> \n' +
      '<li> cloud 3D printer management, </li> \n' +
      '<li> Local print tracking in the cloud, </li> \n' +
      '<li> Stream the image from the camera, </li> \n' +
      '<li> Streaming the printer logo, </li> \n' +
      '<li> Streaming printer statuses, </li> \n' +
      '<li> Extruder and platform temperature streaming. </li> \n' +
      '</ul> \n' +
      '<li> Upload and save files </li> \n' +
      '<li> Storing file version history as projects </li> \n' +
      '<li> Project Management </li> \n' +
      '<li> File and project sharing </li> \n' +
      '<li> Embedded applications: </li> \n' +
      '<ul> \n' +
      '<li> Magic Wand, </li> \n' +
      '<li> STL editor, </li> \n' +
      '<li> GCODE visualizer, </li> \n' +
      '<li> Gcode Analyzer, STL Render, </li> \n' +
      '<li> GCODE render, </li> \n' +
      '<li> Cloud slicer based on Cura 4.6. </li> \n '+
      '</ul> \n' +
      '<li> Cloud Seal Management: </li> \n' +
      '<ul> \n' +
      '<li> send files for printing, </li> \n' +
      '<li> pause, </li> \n' +
      '<li> resume printing, </li> \n' +
      '<li> copying stamps, </li> \n' +
      '<li> restart, </li> \n' +
      '<li> print status tracking. </li> \n '+
      '</ul> \n' +
      '<li> Stamp history storage and filtering </li> \n' +
      '<li> Generate print timelapse </li> \n' +
      '<li> Free Platform Tracking </li> \n' +
      '<li> Platform Occupancy Management </li> \n' +
      '<li> In-system printer sharing </li> \n' +
      '<li> Create, store and manage slicing profiles </li> \n' +
      '<li> Alert email </li> \n' +
      '      </ul>'
  },
  userSettings: {
    auth2fa: '2-Factor Authentication',
    enabled2fa: 'Enabled',
    disabled2fa: 'Disabled',
    enable2fa: 'Enable',
    disable2fa: 'Disable',
    userInfo: 'User Info',
    firstName: 'First name',
    lastName: 'Last name',
    phone: 'Mobile',
    timezone: 'Timezone',
    company: 'Company',
    emailNotificationAfter: 'Get email notification after',
    emailNotifications: {
      'Starting a print job': 'Print job is started',
      'New file is shared to you': 'New file is shared to you',
      'Printing video is generated': 'Printing video is generated',
      'New printer is shared to you': 'New printer is shared to you',
      'New printer is logged into your account': 'New printer is logged into your account',
      'New project is shared to you': 'New project is shared to you'
    },
    saveSettings: 'Save',
    settingsSavedSuccessfully: 'Account settings saved successfully',
    disable2faSuccessfully: '2-Factor Authentication was disabled',
    disable2faFailed: 'Failed to disable 2-Factor Authentication',
    changePassword: 'Change password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    retryNewPassword: 'Retry new password',
    passwordNotMatch: 'The password confirmation does not match',
    passwordChanged: 'Password was successfully changed',
    wrongPassword: 'Wrong password',
    failedChangePassword: 'Failed to change password',
    wrongPasswordLength: 'The password field must be at least 8 characters'
  },
  orgAdmin: {
    navbar: {
      workgroupsAccess: 'Workgroups',
      workgroupPrinters: 'Printers',
      reports: 'Reports',
      users: 'Users',
      workflow: 'Workflow',
      settings: 'Settings',
      newWorkgroupsAccess: 'New workgroups access'
    },
    printers: {
      groups: 'Groups',
      delete: 'Delete'
    },
    workgroupsAccess: {
      manage: {
        tabs: {
          users: 'Users',
          printers: 'Printers',
          settings: 'General',
          wgadmins: 'Moderators'
        },
        workgroup: {
          generate: 'Generate',
          accessCode: 'Access code',
          accessRights: 'Access rights',
          name: 'Name',
        },
        users: {
          add: 'Add',
        }
      }
    },
    users: {
      addUser: 'Add User',
    },
    addUser: {
      email: 'Email',
      accessRole: 'Access Role',
      firstname: 'First Name',
      lastname: 'Last Name',
    }
  },
  modal2fa: {
    title: 'Enable 2-Factor Authentication with Google Authenticator',
    installGoogleAuth: 'Install Google Authenticator on your phone',
    openGoogleAuth: 'Open Google Authenticator app',
    goToQRCode: 'Tap menu, then tap "Set up account", then tap "Scan a QR-Code"',
    scanQRCode: 'Your phone will now be in a "scanning" mode. When you are in the mode, scan the QR-Code below:',
    qrCode: 'QR code',
    failedToLoadQRCode: 'Failed to load QR code',
    enterCode: 'One you have scanned the QR-Code, enter the 6-digit code below:',
    verificationCode: 'Verification Code',
    enabledSuccessfully: '2-Factor Authentication was enabled',
    failedToEnable: 'Failed to enable 2-Factor Authentication'
  },
  router: {
    files: 'My Files',
    projects: 'My Projects',
    profiles: 'My Profiles',
    printers: 'Printers',
    history: 'History',
    search: 'Search',
    download: 'Download',
    account: 'Account',
    color: 'Color',
    liveViewWall: 'Live View Wall',
    releaseNotes: 'Release Notes',
    orgAdmin: {
      workgroups: 'Workgroups',
      printers: 'Printers',
      reports: 'Reports',
      users: 'Users',
      workflow: 'Workflows',
      settings: 'Settings'
    }
  },
  restorePassword: {
    title: 'Password reset',
    reset: 'Reset',
    success: 'Check email for password reset link',
    error: 'Failed to reset password'
  },
  fileJobLog: {
    noJobs: 'No jobs was executed for the file'
  },
  fileGcodeInfo: {
    printer: 'Printer',
    nozzle: 'Nozzle',
    nozzle1: 'Nozzle 1',
    nozzle2: 'Nozzle 2',
    layerHeight: 'Layer',
    infill: 'Infill',
    material: 'Material',
    material1: 'Material 1',
    material2: 'Material 2',
    profile: 'Profile',
    speed: 'Speed',
    weight: 'Weight',
    weight1: 'Weight 1',
    weight2: 'Weight 2',
    textruder: 'Extruder temperature',
    textruder1: 'Extruder temperature 1',
    textruder2: 'Extruder temperature 2',
    ttable: 'Bed temperature',
    tvolume: 'Build volume temperature',
    fan: 'Fan',
    printTime: 'Print time',

    errorGetInfo: 'Error on retrieving information: %{msg}'
  },
  localeSelect: {
    lang: 'Language',
  },
  footer: {
    cloud: '© DiaPrint cloud',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    poweredBy: 'Powered by'
  },
  timezones: {
    0: '(GMT, no daylight saving) Standard'
  }
};
